<template>
  <div class="app-container column-view">

    <el-form label-width="100px" label-position="right"  class="white-block-view-5px padding-20 column-view padding-bottom-0">
      <div class="row-view">
        <el-form-item label="人员姓名" class="row-item">
          <el-input v-model="searchData.name" prefix-icon="el-icon-search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" class="row-item">
          <TimeFilter style="width: 100%" ref="time" @onTime="onTimeSelect"></TimeFilter>
        </el-form-item>
        <div class="row-item"></div>
      </div>
      <div class="row-view">
        <el-form-item label="" class="row-view">
          <div class="row-view">
            <el-button type="primary" icon="el-icon-search" @click="onSearchClick">查询</el-button>
            <el-button type="default"  icon="el-icon-refresh-right"  @click="onResetClick">重置</el-button>
            <div class="margin-left-30">
              <el-button type="success"  icon="el-icon-plus"  @click="()=>{this.$refs.createAddEditEmployee.showDialog()}" class="margin-left-30">新增人员</el-button>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div class="white-block-view-5px margin-top-15 padding-15">
      <el-table :data="list"  v-loading="loading" border size="small" style="min-height: 500px" empty-text="暂没有人员数据哦~" >
        <el-table-column label="序号" align="center" width="100px">
          <template slot-scope="scope">
            <div>{{scope.$index+1}}</div>
          </template>
        </el-table-column>
        <el-table-column label="人员姓名" prop="name" align="center">
        </el-table-column>
        <el-table-column label="性别" prop="gender_msg" align="center">
        </el-table-column>
        <el-table-column label="其他" prop="note" align="center">
        </el-table-column>

        <el-table-column label="创建时间" prop="created_at" align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" style="min-width: 250px">
          <template slot-scope="scope">
            <div style="width: 100%" class="row-view center-view">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="onEditEmployee(scope.row)">编辑</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="onDeleteEmployeeClick(scope.row)">删除</el-button>
            </div>
          </template>

        </el-table-column>
        <template #empty>
          <yc-no-content des="暂没有人员数据哦~"></yc-no-content>
        </template>
      </el-table>

      <el-pagination
        :current-page="searchData.page"
        :page-size="searchData.limit"
        :total="total"
        layout="total, prev, pager, next"
        style="float: right; margin-top: 40px"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <create-add-edit-employee ref="createAddEditEmployee" @onRefreshData="onSearchClick"></create-add-edit-employee>
  </div>
</template>

<script>
//人员管理
import TimeFilter from "@/components/common/TimeFilter";
import createAddEditEmployee from "@/views/setting/employeeManagement/components/createAddEditEmployee";
export default {
  name: "EmployeeManagement",
  components: {TimeFilter,createAddEditEmployee},
  data() {
    return {
      total:0,
      searchData:{
        page:1,
        limit:20,
        name:"",
        created_from: '',//起始时间
        created_to: '',//结束时间
      },
      loading:false,
      list:[]
    }
  },
  methods: {
    handleCurrentChange(val){
      this.searchData.page=val;
      this.onSearchClick();
    },

    onTimeSelect(value){
      this.searchData.created_from = value[0] || ''
      this.searchData.created_to = value[1] || ''
    },
    onEditEmployee(item){
      this.$refs.createAddEditEmployee.setData(item);
    },

    onDeleteEmployeeClick(item){
      this.$prompt('确认删除人员【'+item.name+'】?', '删除人员', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            this.http.api('deleteEmployee', { id: item.id }).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
                done()
                this.onSearchClick()
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '删除'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '删除'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })
    },

    onSearchClick(){
      this.loading=true;
      this.http.api('employeeList',this.searchData)
          .then(res=>{
            this.loading=false;
            if(res.status){
              let data =res.data;
              this.total=data.total;
              this.list=data.data;
            }
          })
          .catch(error=>{
            this.loading=false;
          })
    },


    onResetClick(){
      this.searchData.page=1;
      this.searchData.name='';
      this.searchData.created_from='';
      this.searchData.created_to='';
      this.$refs.time.onClear()
      this.onSearchClick();
    }
  },
  created() {
    this.onSearchClick();
  }
}
</script>

<style scoped>

</style>
